const _i18n_warning = {
  folder_check : {
    EN: `You must specify a folder`,
    KO: `You must specify a folder`,
    JP: `フォルダーを指定する必要があります`
  },
  isolation  : {
    EN: `require the isolation path`,
    KO: `require the isolation path`,
    JP: `隔離パスが必要です`
  },
  isolation_2 : {
    EN: `not allowed ".." string`,
    KO: `not allowed ".." string`,
    JP: `禁止されています ".." 文字列`
  },
  linux : {
    EN: `linux version required linux type path`,
    KO: `linux version required linux type path`,
    JP: `Linux バージョンに必要な Linux タイプのパス`
  },
  window : {
    EN: `windows version required windows type path`,
    KO: `windows version required windows type path`,
    JP: `Windows のバージョンに必要な Windows タイプのパス`
  },
  add_white_list : {
    EN: `It is not included in the scan folder`,
    KO: `It is not included in the scan folder`,
    JP: `スキャンフォルダーには含まれていません`
  }
}

const i18n_toastr = {
  _i18n_warning
}

export default i18n_toastr